import { message } from 'antd';
import api from '../../../services/api';
import { updateOrderItem } from '../reducers';

/**
 * Generic cell save handler for editable table cells
 * Refactored for better maintainability and less code duplication
 */
export const createCellSaveHandler = (dispatch, pagination, fetchOrderItems, forceRefresh = false) => {
    // Define field configurations to reduce duplication
    const fieldConfigs = {
        // Fields that require special validation
        printer: {
            apiField: 'printerId',
            successMessage: 'Printer updated successfully',
            errorMessage: 'Failed to update printer'
        },
        category: {
            apiField: 'categoryId',
            successMessage: 'Category updated successfully',
            errorMessage: 'Failed to update category'
        },
        baseCost: {
            apiField: 'baseCost',
            successMessage: 'Base cost updated successfully',
            errorMessage: 'Failed to update base cost'
        },
        customizationStatus: {
            apiField: 'customizationStatus',
            successMessage: 'Customization status updated successfully',
            errorMessage: 'Failed to update customization status'
        },
        quantity: {
            apiField: 'quantityOrdered',
            successMessage: 'Quantity updated successfully',
            errorMessage: 'Failed to update quantity'
        },
        // Generic text fields
        title: {
            apiField: 'title',
            successMessage: 'Title updated successfully',
            errorMessage: 'Failed to update title'
        },
        sellerSKU: {
            apiField: 'sellerSKU',
            successMessage: 'SKU updated successfully',
            errorMessage: 'Failed to update SKU'
        },
        conditionNote: {
            apiField: 'conditionNote',
            successMessage: 'Condition note updated successfully',
            errorMessage: 'Failed to update condition note'
        },
        note: {
            apiField: 'note',
            successMessage: 'Note updated successfully',
            errorMessage: 'Failed to update note'
        },
        trelloUrl: {
            apiField: 'trelloUrl',
            successMessage: 'Trello URL updated successfully',
            errorMessage: 'Failed to update Trello URL'
        },
        customizationStorageUrl: {
            apiField: 'customizationStorageUrl',
            successMessage: 'Storage URL updated successfully',
            errorMessage: 'Failed to update storage URL'
        },
        carrier: {
            apiField: 'carrier',
            successMessage: 'Carrier updated successfully',
            errorMessage: 'Failed to update carrier'
        },
        trackingNumber: {
            apiField: 'trackingNumber',
            successMessage: 'Tracking number updated successfully',
            errorMessage: 'Failed to update tracking number'
        },
        fulfillmentId: {
            apiField: 'fulfillmentId',
            successMessage: 'Fulfillment ID updated successfully',
            errorMessage: 'Failed to update fulfillment ID'
        },
        fulfillmentStatus: {
            apiField: 'fulfillmentStatus',
            successMessage: 'Fulfillment status updated successfully',
            errorMessage: 'Failed to update fulfillment status'
        },
        shipmentStatus: {
            apiField: 'shipmentStatus',
            successMessage: 'Shipment status updated successfully',
            errorMessage: 'Failed to update shipment status'
        },
        supporterId: {
            apiField: 'supporterId',
            successMessage: 'Supporter updated successfully',
            errorMessage: 'Failed to update supporter'
        },
        isConfirmShipped: {
            apiField: 'isConfirmShipped',
            successMessage: 'Shipment confirmation updated successfully',
            errorMessage: 'Failed to update shipment confirmation'
        }
    };

    return async (record, column, newValue) => {
        try {
            const config = fieldConfigs[column];
            
            if (!config) {
                console.warn('Unknown editable column:', column);
                message.warning(`Field "${column}" is not configured for editing`);
                return false;
            }

            console.log(`Updating ${column} for order item:`, record.id, 'to:', newValue);
            
            // Make API call with the configured field name
            const response = await api.patch(`/orders/items/${record.id}/fields`, {
                [config.apiField]: newValue
            });
            
            if (response.data?.success) {
                message.success(config.successMessage);
                
                if (forceRefresh) {
                    // Refresh the entire table for complex operations
                    dispatch(fetchOrderItems(pagination.current, pagination.pageSize));
                } else {
                    // Update local state for simple field changes
                    dispatch(updateOrderItem({
                        id: record.id,
                        field: config.apiField,
                        value: newValue
                    }));
                }
                
                return true;
            } else {
                message.error(response.data?.message || config.errorMessage);
                return false;
            }
            
        } catch (error) {
            console.error('Error updating cell:', error);
            const errorMessage = error.response?.data?.message || 'Failed to update. Please try again.';
            message.error(errorMessage);
            return false;
        }
    };
};